<template>
  <div style="border-radius: 16px">
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>内容专区运营</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-form
      :inline="true"
      :model="formContent"
      label-width="120px"
      class="searchForm"
    >
      <el-form-item label="专区名称">
        <el-input v-model.trim="formContent.name"></el-input>
        <div style="font-size: 12px">*名称会显示在硬件设备品牌专区</div>
      </el-form-item>

      <br />
      <el-form-item label="专区图片">
        <el-row type="flex" class="row-bg" style="width: 700px">
          <el-col :span="8">
            <el-upload
              class="avatar-uploader"
              ref="uploadxls"
              action="/aries-api/resource/upload"
              :show-file-list="false"
              :before-upload="onBeforeUpload"
              :on-success="onSuccessUpload"
              :data="uploadData"
            >
              <i
                v-show="!formContent.imgUrl"
                class="el-icon-upload avatar-uploader-icon"
              ></i>
              <img :src="formContent.imgUrl" alt="" style="width:100%;height:100%;"/>
              <div
                style="font-size: 12px"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                <!-- *上传图片尺寸为220*72 -->
              </div>
            </el-upload>
          </el-col>
          <el-col :span="4" v-if="formContent.imgUrl != ''">
            <el-button
              size="small"
              type="danger"
              @click="delFrontCover"
              icon="el-icon-delete"
              >删除</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <br />
      <el-form-item>
        <el-button
          type="primary"
          @click="addContentSection"
          icon="arrow-up"
          style="margin-left: 80px"
          >提交</el-button
        >
        <el-button
          type="danger"
          @click="delContentSection"
          icon="arrow-up"
          style="margin-left: 30px"
          >删除当前内容专区</el-button
        >
        <el-button
          type="primary"
          @click="prefecture"
          icon="arrow-up"
          style="margin-left: 30px"
          >专区分享</el-button
        >
      </el-form-item>
    </el-form>

    <div class="tableList">
      <el-form
        :inline="true"
        :model="formSection"
        label-width="120px"
        class="searchForm"
      >
        <el-form-item label="版块名称">
          <el-input v-model="formSection.name"></el-input>
        </el-form-item>
        <el-form-item label="版块ID">
          <el-input v-model="formSection.secId"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="operBtn">
        <el-button type="primary" icon="plus" @click="addSection"
          >新建版块</el-button
        >
        <!-- <el-button type="primary" icon="plus" @click="addSection"
        >创建优惠券</el-button
      > -->
      </div>
      <el-table
        ref="multipleTable"
        :data="queryData"
        :header-cell-style="rowClass"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        v-loading.body="loading"
        id="Table"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          prop="secId"
          label="版块ID"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="secName"
          label="版块名称"
          align="center"
          width="110"
        >
          <!-- <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewTeacher(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.id }}</a
            >
          </template> -->
        </el-table-column>
        <el-table-column
          prop="image"
          label="版块图标"
          align="center"
          min-width="220"
        >
          <template slot-scope="scope">
            <img :src="scope.row.secIcon" alt="" width="220px" height="72px" />
          </template>
        </el-table-column>
        <el-table-column
          prop="secType"
          label="版块类型"
          align="center"
          min-width="80"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.secType == 1">体系课</span>
            <span v-if="scope.row.secType == 2">特色课程</span>
            <span v-if="scope.row.secType == 3">音频资源</span>
          </template></el-table-column
        >
        <el-table-column
          prop="updateAt"
          label="更新时间"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.updateAt | formatDate2 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">已上架</el-tag>
            <el-tag v-else type="danger">未上架</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          show-overflow-tooltip
          align="center"
          width="150"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              ></el-button>
            </el-tooltip>
            <!-- <el-tooltip content="分享" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-share"
                @click="handleShare(scope.row)"
              ></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="分享运营内容"
        :visible.sync="dialogVisible"
        width="60%"
        center
        v-if="step == 0"
      >
        <el-form :model="form" label-width="125px">
          <el-form-item label="*邀请码类型">
            <el-select v-model="form.valueTo" placeholder="请选择">
              <el-option
                v-for="item in InvitationCode"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="form.valueTo == 1 ? '人数' : '*SN数量'">
            <el-select
              v-model="form.peopleNumTo"
              placeholder="请选择"
              v-if="form.valueTo == 1"
            >
              <el-option
                v-for="item in peopleNum"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="form.peopleNumToSelf"
              placeholder="请选择"
              v-if="form.valueTo != 1"
            >
              <el-option
                v-for="item in peopleNumSelf"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="form.valueTo == 1 ? '使用时限' : '*兑换时限'">
            <el-date-picker
              v-model="form.startTime"
              type="date"
              format="yyyy-MM-dd"
              style="width: 180px; font-size: 10px"
            ></el-date-picker>
            至
            <el-date-picker
              v-model="form.endTime"
              type="date"
              format="yyyy-MM-dd"
              style="width: 180px; font-size: 10px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" style="margin: 0;">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <p style="color: red; font-weight: bold;margin-left: 80px;">*听力熊T3，T4系列不支持多层专辑显示</p>
        </el-form>
        <el-button
          @click="creatInvitation"
          style="background-color: #009e7d; color: #ffffff; margin-bottom: 20px"
        >
          {{ form.valueTo == 1 ? "创建邀请码" : "创建专享码" }}
        </el-button>
        <span
          slot="footer"
          class="dialog-footer"
          style="float: right; margin-top: -40px"
        >
          <el-button @click="dialogVisible = false">取消</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="创建成功"
        :visible.sync="dialogVisible"
        width="60%"
        center
        v-if="step == 1"
      >
        <el-form :model="formNext" label-width="80px" v-if="typeValueTo == 1">
          <el-form-item label="邀请码">
            <el-input
              v-model="formNext.Invitation"
              style="width: 220px"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <p v-if="typeValueTo != 1">创建了{{ numPeopleTo }}个专项码</p>
        <el-button
          v-if="typeValueTo == 1"
          @click="copyInvitation"
          style="
            background-color: #009e7d;
            color: #ffffff;
            margin-bottom: 20px;
            margin-top: 20px;
          "
        >
          复制邀请码
        </el-button>
        <el-button
          v-if="typeValueTo != 1"
          @click="checkInvitation"
          style="
            background-color: #009e7d;
            color: #ffffff;
            margin-bottom: 20px;
            margin-top: 20px;
          "
        >
          查看
        </el-button>
        <span
          slot="footer"
          class="dialog-footer"
          style="float: right; margin-top: -40px"
        >
          <el-button @click="dialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
      <div
        style="
          display: flex;
          padding: 10px 20px;
          justify-content: space-between;
        "
      >
        <div class="bottomOperBtn">
          <el-button
            type="danger"
            @click="delSection"
            icon="delete2"
            style="margin-top: 20px"
            >删除</el-button
          >
          <el-button
            type="primary"
            @click="commitSection"
            icon="arrow-up"
            style="margin-top: 20px"
            >上架</el-button
          >
          <el-button
            type="info"
            @click="downSection"
            icon="arrow-down"
            style="margin-top: 20px"
            >下架</el-button
          >
          <el-button
            type="primary"
            @click="handleShare"
            :disabled="dodisabled"
            icon="arrow-up"
            style="margin-top: 20px"
            >版块分享</el-button
          >
        </div>

        <div>
          <el-button
            type="primary"
            @click="shareRecord"
            :disabled="dodisabled"
            icon="arrow-up"
            style="margin-top: 20px"
            >分享记录</el-button
          >
        </div>
      </div>
      <div class="pagination-box" style="padding: 0px 0px 30px 0px !important">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { compareTimeWithNow, formatDateString } from "../commonEdu";
import { ApiMessage, formatDate } from "@/utils/util";
import moment from "moment";

export default {
  name: "contentSection",
  data() {
    return {
      doWhat: "",
      dodisabled: false,
      ids: "", //专区id
      onetargetId: "", //专区商品id
      InvitationCode: [
        { value: 1, label: "邀请码" },
        { value: 2, label: "专享码" },
      ],
      peopleNum: [
        { value: 0, label: "不限" },
        { value: 500, label: "500人" },
        { value: 200, label: "200人" },
        { value: 100, label: "100人" },
      ],
      peopleNumSelf: [
        { value: 500, label: "500人" },
        { value: 200, label: "200人" },
        { value: 100, label: "100人" },
      ],

      form: {
        valueTo: "", //邀请码类型,
        peopleNumTo: 0, //人数限制
        peopleNumToSelf: 100, //专享码人数限制
        startTime: "",
        endTime: "",
        remark: "",
      },
      formNext: {
        Invitation: "",
      },
      queryData: [],
      loading: false,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      formContent: {
        name: "",
        imgUrl: "",
      },
      uploadData: { isOnlyMP3: "false", pdfToPng: "false" },
      dialogVisible: false,
      step: 0, //创建成功翻页状态
      multipleSelection: [],
      doWhy: "",
      sectId: "",
      rowData: [],
      rowId: "", //新建专享码或邀请码id
      numPeopleTo: "",
      typeValueTo: "",
      idsArr: [],
      formSection: {
        name: "",
        secId: "",
      },
    };
  },
  created() {
    this.saveContentSection();
  },
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    // 搜索板块
    onSubmit() {
      this.queryParams.page = 1;
      this.saveContentSection();
    },
    checkStartAndBeginTime(startTime, endTime) {
      let time = new Date(startTime);
      let start = parseInt(time.getTime() / 1000);
      // console.log(begin);
      time = new Date(endTime);
      let end = parseInt(time.getTime() / 1000);
      // console.log(start);
      if (start > end) {
        return true;
      } else {
        return false;
      }
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    onBeforeUpload(file) {
      var imgSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      let validExts = ["jpeg", "png", "jpg"];
      imgSuffix = imgSuffix.toLocaleLowerCase();
      if (!validExts.includes(imgSuffix)) {
        this.$message.error("图片上传格式只支持" + validExts.join(",") + "格式");
        return false;
      }
      // return this.checkImageWH(file, 220, 72);
      return this.checkImageWH(file);
    },
    onSuccessUpload(response, file, fileList) {
      this.formContent.imgUrl = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    uploadSectionFile() {},
    delFrontCover() {
      this.formContent.imgUrl = "";
    },

    detailBeforeUpload(file) {},
    // 限制图片宽高
    checkImageWH(file) {
      // let self = this;
      return new Promise(function (resolve, reject) {
        let filereader = new FileReader();
        filereader.onload = (e) => {
          let src = e.target.result;
          const image = new Image();
          image.onload = function () {
            // if (width && this.width != width) {
            //   alert(
            //     "请上传宽为" + width + "px的图片和高为" + height + "px的图片"
            //   );
            //   reject();
            // } else if (height && this.height != height) {
            //   alert(
            //     "请上传高为" + height + "px的图片和宽为" + width + "px的图片"
            //   );
            //   reject();
            // } else {
              resolve();
            // }
          };

          image.onerror = reject;
          image.src = src;
        };
        filereader.readAsDataURL(file);
      });
    },
    // 新建内容专区
    addContentSection() {
      let params;
      if (this.ids) {
        params = {
          id: new String(this.ids),
          appId: this.$API.APPID,
        };
      } else {
        params = {
          id: "0",
          appId: this.$API.APPID,
        };
      }
      if (this.formContent != null) {
        if (this.formContent.name != "") {
          params.name = this.formContent.name;
        } else {
          alert("专区名称不能为空");
          return;
        }
        if (this.formContent.imgUrl != "") {
          params.icon = this.formContent.imgUrl;
        } else {
          alert("专区图片不能为空");
          return;
        }
      }

      this.$axios
        .post("/edu/eduAdmin/contentzone/save", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.$Message.success("专区运营编辑成功!");
            this.saveContentSection();
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
      console.log("addContentSection");
    },
    delContentSection() {
      let params;
      if (this.ids) {
        params = {
          id: new String(this.ids),
          appId: this.$API.APPID,
        };
      } else {
        alert("请核实内容专区是否存在");
        return;
      }
      this.$Modal.confirm({
        title: "资源用户兑换中，是否删除？",
        content:
          "<ul><li>删除后已兑换用户将无法看资源内容，后台已兑换记录也会清空</li></ul>",
        onOk: () => {
          this.$axios
            .post("/edu/eduAdmin/contentzone/delete", params)
            .then((response) => {
              if (response.data.rc == "0") {
                this.$Message.error("删除成功!");
                this.formContent = {
                  name: "",
                  imgUrl: "",
                };
                this.formNext.Invitation = "";
                this.ids = "";
                this.queryData = [];
              } else {
                alert(response.data.err);
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    // 获取当前内容运营专区
    saveContentSection() {
      // debugger
      let params = {
        appId: this.$API.APPID,
      };
      if (this.formSection.name != "") {
        params.secName = this.formSection.name;
      }
      if (this.formSection.secId != "") {
        params.secId = this.formSection.secId;
      }
      params.incShareInfo = true;
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.$axios
        .post("/edu/eduAdmin/contentzone/detail", params)
        .then((response) => {
          console.log(response, "eee-----------------485");

          if (response.data.rc == "0") {
            let _data = response.data.data;
            this.formContent.name = _data.name;
            this.formContent.imgUrl = _data.icon;
            this.ids = _data.id;
            this.onetargetId = _data.targetId;
            this.queryData = _data.sectionList;
            this.pageTotal = response.data.data.pager.total;
            console.log(_data, "saveContentSection====");
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    // 新建板块
    addSection() {
      console.log(this.ids);
      if (this.ids == "") {
        alert("请核实内容专区");
        return;
      }
      this.doWhy = "add";
      this.$router.push({
        path: "/addSection",
        query: {
          do: this.doWhy,
        },
      });
      console.log("addSection");
    },
    commitSection() {
      this.upDownResource(1);
    },
    downSection() {
      // debugger;
      if (this.multipleSelection.length == 0) {
        alert("请先勾选版块");
        return;
      }
      var con = [];
      var content;
      for (let i in this.multipleSelection) {
        con.push(`${this.multipleSelection[i].isShared}`);
      }
      if (con.includes("true")) {
        content =
          "<ul><li>该版块已分享,下架后兑换资源将无法展示</li>";
      } 
      this.$Modal.confirm({
        title: "确认下架？",
        content: content,
        onOk: () => {
             this.upDownResource(0);
          // let ids = [];
          // for (let i = 0; i < this.multipleSelection.length; ++i) {
          //   let idDel = String(this.multipleSelection[i].secId);
          //   ids.push(idDel);
          // }
          // let params = {
          //   appId: this.$API.APPID,
          //   secIds: ids,
          // };
          // this.$axios
          //   .post("/edu/eduAdmin/contentzone/section_delete", params)
          //   .then((response) => {
          //     console.log(response);
          //     let m = response.data;
          //     if (response.data.rc == "0") {
          //       this.$Message.success("删除成功!");
          //       this.saveContentSection();
          //     } else {
          //       alert(response.data.err);
          //     }
          //     // if (m.result == 0) {
          //     //   this.saveContentSection();
          //     //   this.$Message.success("删除成功!");
          //     // } else {
          //     //   ApiMessage(this, m.err, "error");
          //     // }
          //   })
          //   .catch((error) => {
          //     ApiMessage(this, error.toString(), "error");
          //   });
        },
      });

   
    },
    // 上下架
    upDownResource(online) {
      if (this.multipleSelection.length == 0) {
        alert("请先勾选专辑");
        return;
      }

      console.log(this.multipleSelection);
      let ids = [];
      // var con = [];
      for (let i = 0; i < this.multipleSelection.length; ++i) {
        let id = String(this.multipleSelection[i].secId);
        // con.push(`${this.multipleSelection[i].isShared}`);

        ids.push(id);
      }
      // if (online == 0 && con.includes("true")) {
      //   this.$Message.warning("该版块已分享,下架后兑换资源将无法展示!");
      // }
      let params = {
        appId: this.$API.APPID,
        secIds: ids,
        status: online,
      };
      this.$axios
        .post("/edu/eduAdmin/contentzone/section_online", params)
        .then((response) => {
          console.log(response);
          if (response.data.rc == "0") {
            this.$Message.success("操作成功!");
            this.saveContentSection();
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      console.log(row);
      this.doWhy = "edit";
      this.$router.push({
        path: "/addSection",
        query: {
          sectId: row.secId,
          do: this.doWhy,
        },
      });
    },
    // 分享
    handleShare() {
      if (this.multipleSelection.length == 0) {
        alert("请先勾选版块");
        return;
      }
      this.idsArr = this.multipleSelection.map((item) => {
        return String(item.secId);
      });
      // console.log(ids, "ids===>>>", this.multipleSelection);
      this.doWhat = "";
      this.numPeopleTo = "";
      // this.sectId = row.secId;
      this.form.valueTo = 1;
      this.form.peopleNumTo = 0;
      // this.form.remark = "";
      this.step = 0;
      this.dialogVisible = true;
    },
    // 整个专区分享
    prefecture() {
      this.doWhat = "allDo";
      this.numPeopleTo = "";
      this.sectId = this.ids;
      this.form.valueTo = 1;
      this.form.peopleNumTo = 0;
      // this.form.remark = "";
      this.step = 0;
      this.dialogVisible = true;
    },
    //分享记录
    shareRecord() {
      if ((this.ids = "")) {
        this.dodisabled = true;
      } else {
        this.$router.push({
          path: "/prefectureShare",
          query: {},
        });
      }
    },

    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.saveContentSection();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.saveContentSection();
    },
    delSection() {
      console.log("delSection");
      if (this.multipleSelection.length == 0) {
        alert("请先勾选版块");
        return;
      }
      var con = [];
      var content;
      for (let i in this.multipleSelection) {
        con.push(`${this.multipleSelection[i].isShared}`);
      }
      if (con.includes("true")) {
        content =
          "<ul><li>该版块已分享,删除后分享兑换码失效,已兑换资源将无法展示。</li>";
      } else {
        content = "<ul><li>该版块已分享,删除后兑换资源将无法展示</li>";
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: content,
        onOk: () => {
          let ids = [];
          for (let i = 0; i < this.multipleSelection.length; ++i) {
            let idDel = String(this.multipleSelection[i].secId);
            ids.push(idDel);
          }
          let params = {
            appId: this.$API.APPID,
            secIds: ids,
          };
          this.$axios
            .post("/edu/eduAdmin/contentzone/section_delete", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (response.data.rc == "0") {
                this.$Message.success("删除成功!");
                this.saveContentSection();
              } else {
                alert(response.data.err);
              }
              // if (m.result == 0) {
              //   this.saveContentSection();
              //   this.$Message.success("删除成功!");
              // } else {
              //   ApiMessage(this, m.err, "error");
              // }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    // 创建邀请码
    creatInvitation() {
      // 接口
      //

      console.log(formatDateString(this.form.startTime));
      if (this.form.startTime == "" || this.form.endTime == "") {
        alert("起始时间或结束时间不能为空");
        return;
      } else if (this.form.startTime > this.form.endTime) {
        alert("起始时间不能大于结束时间");
        return;
      }
      let getStartTime = moment(this.form.startTime).unix();
      let getEndTime = moment(this.form.endTime).unix() + (24 * 60 * 60 - 1);
      if (getStartTime == getEndTime) {
        alert("起始时间于结束时间不能为同一天");
        return;
      }
      // console.log(this.form, getStartTime, getEndTime);
      let params = {
        appId: this.$API.APPID,
        // targetId: String(this.sectId),

        personLimit: this.form.peopleNumTo,
        type: this.form.valueTo,
        startTime: getStartTime,
        endTime: getEndTime,
      };
      if (this.doWhat == "allDo") {
        params.targetCategory = 3;
        params.targetId = String(this.sectId);
      } else {
        params.targetCategory = 2;
        params.targetIds = this.idsArr;
      }
      if (this.form.valueTo == 1) {
        params.personLimit = this.form.peopleNumTo;
      } else {
        params.personLimit = this.form.peopleNumToSelf;
      }
      if (this.form.remark != "") {
        params.remark = this.form.remark;
      }
      this.$axios
        .post("/edu/eduAdmin/hxd/invite_code_save", params)
        .then((response) => {
          console.log(response);
          if (response.data.rc == "0") {
            this.step = 1;
            this.rowId = response.data.data.inviteId;

            if (response.data.data.inviteCode) {
              this.typeValueTo = 1;
              this.formNext.Invitation = response.data.data.inviteCode;
            } else {
              this.typeValueTo = 2;
              this.saveinviteCode().then(() => {
                let row = this.rowData.find((item) => {
                  return item.id == this.rowId;
                });
                this.numPeopleTo = row.personLimit;
              });
            }
            this.form = {
              valueTo: "", //邀请码类型,
              peopleNumTo: 0, //人数限制
              peopleNumToSelf: 100,
              startTime: "",
              endTime: "",
              remark: "",
            };
            this.idsArr = [];
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    // 复制邀请码
    copyInvitation() {
      console.log("copyInvitation---copyInvitation");
      this.$copyText(this.formNext.Invitation).then(
        function (e) {
          // debugger;
          alert("复制成功");
        },
        function (e) {
          alert("Can not copy");
        }
      );
    },

    saveinviteCode() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          // targetId: String(this.sectId),
        };
        if (this.doWhat == "allDo") {
          params.targetId = String(this.onetargetId);
        } else {
          params.targetId = String(this.sectId);
        }
        this.$axios
          .post("/edu/eduAdmin/hxd/invite_code_list", params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              this.rowData = response.data.data.list;
              resolve();
            } else {
              alert(response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    // 查看专享码
    async checkInvitation() {
      await this.saveinviteCode();
      console.log(
        this.rowData,
        "rowDatarowDatarowDatarowDatarowDatarowData",
        this.rowId
      );
      let row = this.rowData.find((item) => {
        return item.id == this.rowId;
      });
      const routeData = this.$router.resolve({
        path: "/invitationDetail",
        query: row,
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style  scoped>
.tableList {
  margin-top: 50px;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
}

.tableList > #Table {
  width: 98%;
  margin: -10px auto;
}
.tableList > .bottomOperBtn {
  padding: 10px 20px;
  float: left;
}
.avatar-uploader {
  display: flex;
  flex-direction: column;
}

.avatar-uploader >>> .el-upload {
  width: 220px;
  height: 72px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader >>> .el-upload:hover {
  border-color: #409eff;
}

/* .avatar-uploader >>> .el-upload .el-upload--text {
} */
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 72px;
  line-height: 72px;
  text-align: center;
}
.avatar {
  width: 220px;
  height: 72px;
  display: block;
}
.el-button--primary:hover,
.el-button--primary {
  color: #fff;
  background-color: #009e7d !important;
  border-color: #009e7d !important;
}

.el-button--primary.is-disabled {
  color: #fff;
  background-color: #a9cabf !important;
  border-color: #a9cabf !important;
}
.operBtn {
  float: right;
  margin-bottom: 20px;
}

.pagination-box {
  padding: 74px 10px 30px 10px !important;
}
</style>



// WEBPACK FOOTER //
// contentSection.vue?2407a35e